// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mr-t-10 {\n  margin-top: 10px;\n}\n.btn-delete {\n  float: right;\n  color: red !important;\n  cursor: pointer;\n}\n.mt--075 {\n  margin-top: -0.75rem;\n}\n", ""]);
// Exports
module.exports = exports;
